import styled from "styled-components";

export const Main = styled.div`
   display: flex;
   
   .otherSvg {
      width: 18px;
      height: 18px;

      svg {
         width: 100%;
         height: 100%;
      }
   }
`;